module.exports = __webpack_public_path__ + "img/big_bar_frame.1be491e1.png";